import { BaseEffectsLayer, SequencerInterfaceLayer, UIEffectsLayer, } from "./canvas-effects/effects-layer.js";
import { debug } from "./lib/lib.js";

export default function registerLayers() {
	CONFIG.Canvas.layers = foundry.utils.mergeObject(foundry.canvas.Canvas.layers, {
		sequencerEffects: {
			layerClass: BaseEffectsLayer,
			group: "interface",
		},
		sequencerInterfaceLayer: {
			layerClass: SequencerInterfaceLayer,
			group: "interface",
		},
		sequencerEffectsUILayer: {
			layerClass: UIEffectsLayer,
			group: "interface",
		},
	});

	debug("Registered Layers");
}
